'use strict'
require('core-js/modules/es.array.filter')
require('core-js/modules/es.array.for-each')
require('core-js/modules/es.array.join')
require('core-js/modules/es.array.map')
require('core-js/modules/es.object.keys')
require('core-js/modules/web.dom-collections.for-each')
exports.__esModule = true
exports.default = _default

var _is = require('../is')

function _default(cls, classObj, staticClasses) {
  var clArr = Object.keys(cls).filter(function(cl) {
    return cls[cl]
  })

  if ((0, _is.isObj)(classObj)) {
    var obj = classObj
    clArr = clArr
      .map(function(cl) {
        return obj[cl]
      })
      .filter(function(cl) {
        return (0, _is.isStr)(cl)
      })
  }

  if ((0, _is.isObj)(staticClasses)) {
    var _obj = staticClasses
    Object.keys(_obj).forEach(function(key) {
      if (_obj[key]) {
        clArr.push(key)
      }
    })
  }

  return clArr.join(' ')
}



//////////////////
// WEBPACK FOOTER
// ./~/hlp/dist/react/calcClasses.js
// module id = 642
// module chunks = 0